import _classCallCheck from "/working_dir/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/working_dir/frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/working_dir/frontend/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/working_dir/frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/working_dir/frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { useId, useRef, useInsertionEffect } from 'react';
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */

var PopChildMeasure = /*#__PURE__*/function (_React$Component) {
  _inherits(PopChildMeasure, _React$Component);

  var _super = _createSuper(PopChildMeasure);

  function PopChildMeasure() {
    _classCallCheck(this, PopChildMeasure);

    return _super.apply(this, arguments);
  }

  _createClass(PopChildMeasure, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var element = this.props.childRef.current;

      if (element && prevProps.isPresent && !this.props.isPresent) {
        var size = this.props.sizeRef.current;
        size.height = element.offsetHeight || 0;
        size.width = element.offsetWidth || 0;
        size.top = element.offsetTop;
        size.left = element.offsetLeft;
      }

      return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return PopChildMeasure;
}(React.Component);

function PopChild(_ref) {
  var children = _ref.children,
      isPresent = _ref.isPresent;
  var id = useId();
  var ref = useRef(null);
  var size = useRef({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  /**
   * We create and inject a style block so we can apply this explicit
   * sizing in a non-destructive manner by just deleting the style block.
   *
   * We can't apply size via render as the measurement happens
   * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
   * styles directly on the DOM node, we might be overwriting
   * styles set via the style prop.
   */

  useInsertionEffect(function () {
    var _size$current = size.current,
        width = _size$current.width,
        height = _size$current.height,
        top = _size$current.top,
        left = _size$current.left;
    if (isPresent || !ref.current || !width || !height) return;
    ref.current.dataset.motionPopId = id;
    var style = document.createElement("style");
    document.head.appendChild(style);

    if (style.sheet) {
      style.sheet.insertRule("\n          [data-motion-pop-id=\"".concat(id, "\"] {\n            position: absolute !important;\n            width: ").concat(width, "px !important;\n            height: ").concat(height, "px !important;\n            top: ").concat(top, "px !important;\n            left: ").concat(left, "px !important;\n          }\n        "));
    }

    return function () {
      document.head.removeChild(style);
    };
  }, [isPresent]);
  return React.createElement(PopChildMeasure, {
    isPresent: isPresent,
    childRef: ref,
    sizeRef: size
  }, React.cloneElement(children, {
    ref: ref
  }));
}

export { PopChild };